<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
  <img src="assets/img/svg/esmart-logo.svg" alt="Energy Market Price Logo" />

  <img src="assets/img/svg/robot-circle.svg" />

  <h3>Create New Password</h3>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
    <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" />

    @if (form.controls.password.hasError('required')) {
      <mat-error>{{ 'FORM__ERROR__REQUIRED' | translate }}</mat-error>
    }

    @if (form.controls.password.hasError('minlength')) {
      <mat-error>Min Length {{ form.controls.password.errors['minlength'].requiredLength }} </mat-error>
    }

    <button type="button" matSuffix class="es-btn-icon" (click)="hidePassword = !hidePassword">
      <span class="material-symbols-rounded-m">
        {{ hidePassword ? 'visibility' : 'visibility_off' }}
      </span>
    </button>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ 'LOGIN__CONFIRM_NEW_PASSWORD' | translate }}</mat-label>
    <input matInput formControlName="confirmPassword" [type]="hidePassword ? 'password' : 'text'" />

    @if (form.controls.confirmPassword.hasError('required')) {
      <mat-error>{{ 'FORM__ERROR__REQUIRED' | translate }}</mat-error>
    }

    @if (form.controls.confirmPassword.hasError('minlength')) {
      <mat-error>
        {{
          'FORM__ERROR__REQUIRED_CHARACTERS'
            | translate: { param: form.controls.confirmPassword.errors['minlength'].requiredLength }
        }}
      </mat-error>
    }

    @if (form.controls.confirmPassword.hasError('notSame')) {
      <mat-error>
        {{ 'FORM__ERROR__PASSWORD_MATCH' | translate }}
      </mat-error>
    }

    <button type="button" matSuffix class="es-btn-icon" (click)="hidePassword = !hidePassword">
      <span class="material-symbols-rounded-m">
        {{ hidePassword ? 'visibility' : 'visibility_off' }}
      </span>
    </button>
  </mat-form-field>

  <button class="es-btn es-btn-lg es-btn-accented">RESET PASSWORD</button>
</form>
